import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker only in production builds. In dev mode, CRA's
// hot-reload + a service worker tend to fight each other and cache stale
// chunks. The Capacitor wrapper (future) will set window.Capacitor, in which
// case we also skip — Capacitor bundles assets natively and a SW just adds
// stale-cache risk without offline benefit.
if (
  process.env.NODE_ENV === 'production' &&
  'serviceWorker' in navigator &&
  !(window as any).Capacitor
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('SW registration failed:', err);
      });
  });
}
